"use client";

import { Suspense, type ReactNode } from "react";
import { useSearchParams } from "next/navigation";

/** Render the URL-independent view in HTML, then apply the current query in the browser. */
export function SearchParamsBoundary({
  children,
}: {
  children: (params: URLSearchParams) => ReactNode;
}) {
  return (
    <Suspense fallback={children(new URLSearchParams())}>
      <SearchParamsContent>{children}</SearchParamsContent>
    </Suspense>
  );
}

function SearchParamsContent({
  children,
}: {
  children: (params: URLSearchParams) => ReactNode;
}) {
  const params = useSearchParams();
  return children(new URLSearchParams(params.toString()));
}
